/**
 * Service Shop - utilise les cookies SSO pour l'authentification
 */

const API_BASE_URL = `${process.env.REACT_APP_API_URL || 'http://api.local.dev:8080'}/api/shop`;

class ShopService {
  async getUsers(page = 1, limit = 20, search = null, status = null) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString()
      });
      
      if (search) params.append('search', search);
      if (status) params.append('status', status);

      const response = await fetch(`${API_BASE_URL}/users?${params}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Utilise les cookies SSO
      });

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Erreur lors de la récupération des utilisateurs:', error);
      throw error;
    }
  }

  async getRoles(includeInactive = false) {
    try {
      const params = new URLSearchParams();
      if (includeInactive) {
        params.append('include_inactive', 'true');
      }

      const response = await fetch(`${API_BASE_URL}/roles?${params}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Erreur lors de la récupération des rôles:', error);
      throw error;
    }
  }

  async assignRole(userId, roleId, context = null) {
    try {
      const response = await fetch(`${API_BASE_URL}/users/assign-role`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          user_id: userId,
          role_id: roleId,
          context: context
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `Erreur ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Erreur lors de l\'assignation du rôle:', error);
      throw error;
    }
  }

  async removeRole(userId, roleId, context = null) {
    try {
      const response = await fetch(`${API_BASE_URL}/users/remove-role`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          user_id: userId,
          role_id: roleId,
          context: context
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `Erreur ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Erreur lors de la suppression du rôle:', error);
      throw error;
    }
  }

  async createCreator(businessName, cguAccepted) {
    try {
      const response = await fetch(`${API_BASE_URL}/creator/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          business_name: businessName,
          cgu_accepted: cguAccepted
        }),
      });

      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Réponse non-JSON reçue:', text);
        return { success: false, error: 'Le serveur a retourné une réponse invalide' };
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erreur lors de la création de la boutique:', error);
      return { success: false, error: error.message || 'Erreur lors de la création de la boutique' };
    }
  }
}

export default new ShopService();




